__turbopack_context__.v({
  "aside": "search-layout-module-scss-module__jWpuLa__aside",
  "asideStickyContainer": "search-layout-module-scss-module__jWpuLa__asideStickyContainer",
  "buttonWrapper": "search-layout-module-scss-module__jWpuLa__buttonWrapper",
  "closeButton": "search-layout-module-scss-module__jWpuLa__closeButton",
  "contentSplit": "search-layout-module-scss-module__jWpuLa__contentSplit",
  "filtersButton": "search-layout-module-scss-module__jWpuLa__filtersButton",
  "fixedAside": "search-layout-module-scss-module__jWpuLa__fixedAside",
  "inverted": "search-layout-module-scss-module__jWpuLa__inverted",
  "main": "search-layout-module-scss-module__jWpuLa__main",
  "open": "search-layout-module-scss-module__jWpuLa__open",
  "title": "search-layout-module-scss-module__jWpuLa__title",
});
